import {inject, Injectable} from '@angular/core';
import {MatSnackBar, MatSnackBarConfig} from '@angular/material/snack-bar';
import {ESnackbarType} from '@entities/ui/snackbar';
import {SnackbarContentComponent} from '@shared/components/snackbar-content/snackbar-content.component';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  private snackBar = inject(MatSnackBar);

  public open(
    message: string,
    type: ESnackbarType = ESnackbarType.Success,
    duration = 3000
  ): void {
    const config: MatSnackBarConfig = {
      duration,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: [type],
      data: message,
    };

    this.snackBar.openFromComponent(SnackbarContentComponent, config);
  }
}
